import React from 'react'
import { Slide } from 'react-toastify'

import { isDesktop } from 'utils/device'

import { ToastContainerComponent } from './styles'

import { NOTIFICATION_POSITIONS } from '../Notification'

const ToastContainer = () => {
    const mobileStyles = !isDesktop
        ? {
              bottom: '20%',
          }
        : {}

    return (
        <ToastContainerComponent
            transition={Slide}
            position={NOTIFICATION_POSITIONS.BOTTOM_LEFT}
            autoClose={3000}
            hideProgressBar
            newestOnTop
            closeOnClick
            closeButton={false}
            rtl={false}
            draggable={false}
            pauseOnHover
            limit={4}
            style={mobileStyles}
        />
    )
}

export { ToastContainer }
